var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Layout } from '~/core/decorator';
import { namespace } from 'vuex-class';
import DataForm from '~/components/common/data-form.vue';
import DataBox from '~/components/common/data-box.vue';
import NumberRange from '~/components/common/number-range.vue';
import AddData from '~/components/assist-work/dia-log/add-data.vue';
var inrushCaseModule = namespace('inrush-case');
// @Auth(77)
var DataTrain = /** @class */ (function (_super) {
    __extends(DataTrain, _super);
    function DataTrain() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryParamsModel = {
            name: "",
            mobileNo: "",
            hand: "",
            appointCaseData: ""
        };
        _this.dialog = {
            addData: false,
        };
        _this.undistributedModel = {};
        _this.currentData = {};
        return _this;
    }
    DataTrain.prototype.addDataClick = function () {
        this.dialog.addData = true;
    };
    DataTrain.prototype.data = function () {
        return {
            tableData: [{
                    appointCaseData: '2016-05-02',
                    cardNumber: '调解系统培训',
                    auth: '管理员1',
                    body: '资料一'
                }, {
                    appointCaseData: '2016-05-02',
                    cardNumber: 'a',
                }, {
                    appointCaseData: '2016-05-02',
                    cardNumber: 'v',
                }, {
                    appointCaseData: '2016-05-02',
                    cardNumber: 'f',
                }
            ]
        };
    };
    DataTrain.prototype.handleCommand = function () {
    };
    DataTrain.prototype.refreshData = function () {
    };
    DataTrain.prototype.rowClick = function (row, event, column) {
        this.currentData = row;
    };
    DataTrain = __decorate([
        Layout('workspace'),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                NumberRange: NumberRange,
                AddData: AddData,
            }
        })
    ], DataTrain);
    return DataTrain;
}(Vue));
export default DataTrain;
